import lodash from 'lodash';

import {EASINGS} from '../../ecs/easingHelper';
import easeInLeftGif from '../../../assets/images/transitions/easeInLeft.gif';

/**
 * The name that signals this preset.
 * @const {string}
 */
export const PRESET_EASE_IN_LEFT = 'easeInLeft';

/**
 * The preset details.
 *
 * @type {{
 *   name: string,
 *   humanName: string,
 *   flow: string,
 *   details: Object.<string, {
 *     easing: string,
 *     parse: boolean,
 *     values: *|Array.<*>,
 *     time: {start: (string|number), end: (string|number)}
 *   }>,
 *   template: {}
 * }}
 */
export const easeInLeftPresetDetails = {
  // The name of the preset.
  name: PRESET_EASE_IN_LEFT,

  // A human friendly name for the preset.
  humanName: 'Ease In & Rotate From Left',

  // A preview of the transition.
  gif: easeInLeftGif,

  // The element names that this preset can be used for or true for all elements.
  elements: true,

  // The preset direction: in, out, middle. This is used in the UI logic.
  flow: 'in',

  // Each property that will change during the transition.
  details: {
    'position.x': {
      time: {
        start: 'start.0',
        end: 'start.1000'
      },
      easing: EASINGS.easeOutPower3,
      values: [
        'off.left',
        'position.left'
      ],
      immediateRender: true
    },
    'transform.rotate': {
      time: {
        start: 'start.0',
        end: 'start.1000'
      },
      easing: EASINGS.easeOutPower3,
      values: [
        '90',
        '0'
      ],
      immediateRender: true
    },
  },

  // How this preset can be used in the source (including optional parameters).
  // This will be turned into a JSON string, so no functions can be used.
  template: {
    preset: PRESET_EASE_IN_LEFT,
    options: {},
  },
};

easeInLeftPresetDetails.template.options = lodash.cloneDeep(easeInLeftPresetDetails.details);

// This defines the key in the presets object.
export const presetName = PRESET_EASE_IN_LEFT;

// This defines the value of the presets object.
export default easeInLeftPresetDetails;
